module.exports = __webpack_public_path__ + "media/images/pc/brands/aqua/store_yokohama-a6393ac6c24cd7920a287681693d2fd5.jpg";